import React, { useEffect, useRef } from 'react';

// Import all images (reusing the same assets you already had)
import img5709 from '../Images/IMG_5709.jpg';
import img5704 from '../Images/sf.jpg';
import img5707 from '../Images/IMG_5707.jpg';
import img5544 from '../Images/IMG_5544.jpg';
import img5584 from '../Images/IMG_5584.jpg';
import chicago from '../Images/chicago.jpg';
import chicago1 from '../Images/chicago1.jpg';
import chicago2 from '../Images/chicago2.jpg';
import hanoi from '../Images/hanoi.jpg';
import hanoi1 from '../Images/hanoi1.jpg';
import hanoi3 from '../Images/hanoi3-silent.mp4';
import morehanoi from '../Images/morehanoi.jpg';
import moresf from '../Images/moresf.jpg';
import moresf1 from '../Images/moresf1.jpg';
import moresf2 from '../Images/moresf2.jpg';

const sequences = [
  {
    id: 'sf-2026',
    title: 'San Francisco Bay Area',
    subtitle: '2026',
    items: [
      { src: '/photos/bay-area-2026/yosemite.jpg', alt: 'Yosemite Valley beneath a clear blue sky', type: 'image', landscape: true },
      { src: '/photos/bay-area-2026/redwoods.jpg', alt: 'A trail winding between towering redwoods', type: 'image' },
      { src: '/photos/bay-area-2026/sailboat.jpg', alt: 'A sailboat on the bay beneath the hills', type: 'image' },
      { src: '/photos/bay-area-2026/clip-1026.mp4', poster: '/photos/bay-area-2026/clip-1026.jpg', alt: 'Birds over the coast at sunset', type: 'video', landscape: true },
    ],
  },
  {
    id: 'sf',
    title: 'San Francisco Bay Area',
    subtitle: '2025',
    items: [
      { src: img5704, alt: 'SF 2', type: 'image' },
      { src: img5544, alt: 'SF 3', type: 'image' },
      { src: img5709, alt: 'SF 4', type: 'image' },
      { src: img5707, alt: 'SF 5', type: 'image' },
      { src: img5584, alt: 'SF 6', type: 'image' },
      { src: moresf, alt: 'SF 7', type: 'image' },
      { src: moresf1, alt: 'SF 8', type: 'image' },
      { src: moresf2, alt: 'SF 9', type: 'image' },
    ],
  },
  {
    id: 'chicago',
    title: 'Chicago',
    subtitle: '2025',
    items: [
      { src: chicago, alt: 'Chicago 1', type: 'image' },
      { src: chicago1, alt: 'Chicago 2', type: 'image' },
      { src: chicago2, alt: 'Chicago 3', type: 'image' },
    ],
  },
  {
    id: 'hanoi',
    title: 'Vietnam',
    subtitle: '2025',
    items: [
      { src: '/photos/vietnam-2025/flags.jpg', alt: 'Vietnamese flags above a tree-lined street in Hanoi', type: 'image' },
      { src: hanoi, alt: 'Hanoi 1', type: 'image' },
      { src: hanoi1, alt: 'Hanoi 2', type: 'image' },
      { src: hanoi3, poster: '/photos/vietnam-2025/street-video.jpg', alt: 'Hanoi street scene', type: 'video' },
      { src: morehanoi, alt: 'Hanoi 4', type: 'image' },
    ],
  },
];

function GalleryVideo({ media }) {
  const ref = useRef(null);
  useEffect(() => {
    const video = ref.current;
    if (!window.IntersectionObserver) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) video.pause();
      else if (!window.matchMedia('(max-width: 760px), (hover: none), (prefers-reduced-motion: reduce)').matches && !navigator.connection?.saveData) video.play().catch(() => {});
    }, { threshold: .25 });
    observer.observe(video);
    return () => observer.disconnect();
  }, []);
  return <video ref={ref} src={media.src} poster={media.poster} aria-label={media.alt} controls preload="none" loop muted playsInline />;
}

const Gallery = ({ sequence }) => {
  return (
    <div className="sequence-gallery">
      <div className="sequence-grid">
        {sequence.items.map((media, idx) => (
          <div key={idx} className={`picture-item${media.landscape ? ' picture-landscape' : ''}`}>
            {media.type === 'video' ? (
              <GalleryVideo media={media} />
            ) : (
              <img src={media.src} alt={media.alt} loading="lazy" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const GalleryPanel = ({ sequence }) => {
  return (
    <div className="preview-panel preview-panel-scroll" onClick={(e) => e.stopPropagation()}>
      <div className="preview-content">
        <p className="preview-intro">{sequence.title}</p>
        <p className="preview-description">{sequence.subtitle}</p>
        <Gallery sequence={sequence} />
      </div>
    </div>
  );
};

// Mobile inline gallery component
const MobileGallery = ({ sequence }) => {
  return (
    <div className="mobile-sequence-gallery">
      {sequence.items.map((media, idx) => (
        <div key={idx} className="mobile-gallery-item">
          {media.type === 'video' ? (
            <GalleryVideo media={media} />
          ) : (
            <img 
              src={media.src} 
              alt={media.alt} 
              loading="lazy"
              style={{ width: '100%', height: 'auto', display: 'block', borderRadius: '8px' }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

// Export as a list + helpers to keep App.js clean.
sequences.Gallery = Gallery;
sequences.GalleryPanel = GalleryPanel;
sequences.MobileGallery = MobileGallery;

export default sequences;





